import { render, staticRenderFns } from "./StoryPlayFullscreen.vue?vue&type=template&id=cf4f8f80&scoped=true"
import script from "./StoryPlayFullscreen.vue?vue&type=script&lang=js"
export * from "./StoryPlayFullscreen.vue?vue&type=script&lang=js"
import style0 from "./StoryPlayFullscreen.vue?vue&type=style&index=0&id=cf4f8f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4f8f80",
  null
  
)

export default component.exports